import React from "react";

function Team() {
  return (
    <section className="tc-team-style1 pt-100 pb-100">
      <div className="container">

        <div className="text-center mb-80 js-splittext-lines">
          <h2 className="fsz-45">The Mind Behind Every Design</h2>
        </div>

        <div className="row align-items-center">

          {/* Founder Image */}
         {/* Founder Image */}
<div className="col-lg-5 mb-5 mb-lg-0 wow fadeInLeft">
  <div
    style={{
      position: "relative",
      maxWidth: "480px",
      margin: "0 auto",
    }}
  >
    {/* Decorative offset frame */}
    <div
      style={{
        position: "absolute",
        top: "-18px",
        left: "-18px",
        width: "100%",
        height: "100%",
        border: "2px solid #a56236",
        borderRadius: "12px",
        zIndex: 0,
      }}
    />

    {/* Image */}
    <div
      className="founder-img-wrap"
      style={{
        position: "relative",
        zIndex: 1,
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
      }}
    >
      <img
        src="/home1/assets/img/team/founder.jpeg"
        alt="Sukhmeet Singh"
        className="img-contain w-100"
        style={{ display: "block" }}
      />
    </div>
  </div>
</div>

          {/* Founder Content */}
          <div className="col-lg-7 ps-lg-5 wow fadeInRight">

            <span
              className="text-uppercase"
              style={{
                color: "#a56236",
                letterSpacing: "2px",
                fontWeight: "600",
              }}
            >
              Founder & Principal Architect
            </span>

            <h2 className="mt-3 mb-4">Sukhmeet Singh</h2>

            <p className="color-666 mb-4">
              At SS Architects & Interiors, I believe every space should tell a
              story—one that reflects the people who live in it. My approach
              combines thoughtful planning, modern aesthetics, and practical
              functionality to create homes that are elegant, comfortable, and
              timeless.
            </p>

            <p className="color-666 mb-4">
              Every project is a collaboration built on trust, creativity, and
              attention to detail. From the first concept to the final
              execution, my goal is to design spaces that not only look
              exceptional but also enhance everyday living and remain relevant
              for years to come.
            </p>

            <blockquote
              className="mt-5 ps-4"
              style={{
                borderLeft: "3px solid #a56236",
              }}
            >
              <p
                className="mb-2"
                style={{
                  fontSize: "20px",
                  fontStyle: "italic",
                }}
              >
                "Great design is not just about creating beautiful spaces—it's
                about designing environments that improve the way people live."
              </p>

              <h6 className="mt-3 mb-0">— Sukhmeet Singh</h6>
            </blockquote>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Team;